import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['ready', 'starting', 'failed', 'loading', 'unavailable']);
const localhostHosts = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

export function isRuntimeStatusVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const fixtureState = url.searchParams.get('enrichRuntimeStatusFixture') || '';

  return (
    localhostHosts.has(url.hostname) &&
    url.pathname === '/enrich/runtime-status' &&
    allowedFixtureStates.has(fixtureState)
  );
}

export const runtimeStatusVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;
  return isRuntimeStatusVisualFixtureUrl(window.location.href);
};
